module.exports = __webpack_public_path__ + "img/img_arrow.996b94dc.svg";